import { gql } from '@apollo/client';

export const USER_CONFIGURATION_QUERY_NAME = 'UserConfiguration';
export const USER_CONFIGURATION = gql`
    query ${USER_CONFIGURATION_QUERY_NAME} {
        userConfiguration {
            hasTrustedDevice,
            bidding {
                defaultPrice
                defaultQuantity
                priceStep
                quantityStep
                allowedBiddingTypes
            }
        }
    }
`;

export const REVOKE_TRUSTED_DEVICES = gql`
    mutation updateTrustedDeviceUserConfiguration {
        updateTrustedDeviceUserConfiguration
    }
`;

export const UPDATE_BIDDING_USER_CONFIGURATION = gql`
    mutation UpdateBiddingUserConfiguration(
        $defaultPrice: Price,
        $defaultQuantity: Int,
        $priceStep: Price,
        $quantityStep: Int,
    ) {
        updateBiddingUserConfiguration(
            defaultPrice: $defaultPrice,
            defaultQuantity: $defaultQuantity,
            priceStep: $priceStep,
            quantityStep: $quantityStep,
        ) {
            defaultPrice
            defaultQuantity
            priceStep
            quantityStep
        }
    }
`;
